import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import swal from "sweetalert2";

function Getallrooms() {
    const [rooms, setRooms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {
        const fetchRooms = async () => {
            try {
                setLoading(true);
                const response = await axios.get("https://online-hotels-booking-system-server.vercel.app/api/rooms/getallrooms");
                setRooms(response.data);
                setLoading(false);
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        };

        fetchRooms();
    }, []);

	const deleteRoom = async (roomId) => {
		try {
			setLoading(true);
			await axios.delete(`https://online-hotels-booking-system-server.vercel.app/api/rooms/deleteroom/${roomId}`);
			setRooms(rooms.filter(room => room._id !== roomId));
			setLoading(false);
			swal.fire("Deleted!", "Room has been deleted.", "success");
		} catch (error) {
			setError(true);
			setLoading(false);
			swal.fire("Oops", "Something went wrong", "error");
		}
	};
    return (
        <div className="row">
            <div className="col-md-12">
                <h1>Rooms</h1>
                {loading && <Loader />}
                {error && <p>Something went wrong. Please try again later.</p>}
                <table className="table table-bordered table-dark">
                    <thead className="bs">
                        <tr>
                            <th>Room ID</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Rent Per Day</th>
                            <th>Max Count</th>
                            <th>Phone Number</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rooms.length && rooms.map((room) => (
                            <tr key={room._id}>
                                <td>{room._id}</td>
                                <td>{room.name}</td>
                                <td>{room.type}</td>
                                <td>{room.
									rentpreday}</td>
                                <td>{room.maxcount}</td>
                                <td>{room.phonenumber}</td>
                                <td>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => deleteRoom(room._id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Getallrooms;